/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import logoPng from 'images/coffe_and_ponchik.png'
import { ReactComponent as AlohaIcon } from 'images/icons/aloha_icon.svg'
import { isAloha } from 'application/utils/outletNet'

import s from './Loader.module.scss'

const AppLoader = () => {
  return <div className={s.app_loader}>{isAloha() ? <AlohaIcon /> : <img src={logoPng} />}</div>
}
export default React.memo(AppLoader)
